import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

import Home from "./pages/home/home";
import DiecastStore from "./pages/pop/pop";
import Vendor from "./pages/vendar/vendor";

import HeaderNav from "./Components/Header/HeaderNav";
import Footer from "./Components/Footer/Footer";
import Cart from "./Components/Cart/Cart";
import Favorites from "./Components/Favorites/favorites";

import SignUp from "./Components/auth/SignUpForm";
import Profile from "./pages/Profile/profile";
import ContactPage from "./pages/contact/contact";
import ExclusiveProducts from "./pages/Event Exclusive/exclusive"
import Checkout from "./pages/Checkout/Checkout";
import PaymentProcessing from "./pages/Checkout/PaymentProcessing";
import OrderConfirmation from "./pages/Order Confirmation/order_comformation";
import Membership from "./pages/membership/member";
import MembershipRequestPage from "./pages/membership/membershiprequestpage";
import ComboListing from "./pages/combos/ComboListing";
import ComboDetail from "./pages/combos/ComboDetail";
import SearchResults from "./pages/serachpage/search_result";
import Redeempage from "./pages/redeem/Redeempage";
import RedeemDetailPage from "./pages/redeem/RedeemDetailPage";
// Re-enable these imports when the clearance-sale routes below go live again.
// import ClearancePage from "./pages/clearance/ClearancePage";
// import ClearanceDetailPage from "./pages/clearance/ClearanceDetailPage";
import { useAuth } from "./context/AuthContext";
import AboutUs from "./pages/About Us/about_us";
import PrivacyPolicy from "./pages/privacypolicy/privacy_policy";
import TermsAndConditions from "./pages/terms/terms-conditions";
import SignInModal from "./Components/auth/SignInModal";
import ShippingDelivery from "./shipping_delivery/shippingdelivery";
import PreOrderPage from "./pages/preorder/PreOrderPage";
import {
  fetchProfileDashboard,
  hasRequiredAddressInfo,
  hasRequiredPersonalInfo,
} from "./api/profile.api";

const PROFILE_COMPLETION_PROMPT_KEY = "show_profile_completion_prompt";

function App() {
  const [cartOpen, setCartOpen] = useState(false);
  const [favoritesOpen, setFavoritesOpen] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [profilePromptOpen, setProfilePromptOpen] = useState(false);
  const whatsappUrl = "https://wa.me/917902826149";

  const { isAuthenticated, showLoginModal, setShowLoginModal } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    if (typeof window === "undefined") return;
    if (window.sessionStorage.getItem(PROFILE_COMPLETION_PROMPT_KEY) !== "1") {
      return;
    }

    let mounted = true;

    fetchProfileDashboard()
      .then((profile) => {
        if (!mounted) return;

        const missingPersonal = !hasRequiredPersonalInfo(profile?.personal_info);
        const missingAddress = !hasRequiredAddressInfo(profile?.default_address);

        if (missingPersonal || missingAddress) {
          setProfilePromptOpen(true);
          return;
        }

        window.sessionStorage.removeItem(PROFILE_COMPLETION_PROMPT_KEY);
      })
      .catch(() => {
        if (!mounted) return;
        setProfilePromptOpen(true);
      });

    return () => {
      mounted = false;
    };
  }, [isAuthenticated]);

  return (
    <>
      <HeaderNav
        onCartClick={() => setCartOpen(true)}
        onFavoritesClick={() => setFavoritesOpen(true)}
        onUserClick={() => {
          setShowLoginModal(true);
          setIsSignUp(false);
        }}
      />

      {profilePromptOpen && (
        <div className="app-profile-prompt-backdrop">
          <div className="app-profile-prompt-card">
            <h3>Welcome</h3>
            <p>
              Your account is ready. Please add your personal information and address details so
              placing orders will be smooth and hassle-free.
            </p>
            <div className="app-profile-prompt-actions">
              <button
                type="button"
                className="app-profile-prompt-btn secondary"
                onClick={() => {
                  setProfilePromptOpen(false);
                  window.sessionStorage.removeItem(PROFILE_COMPLETION_PROMPT_KEY);
                }}
              >
                Later
              </button>
              <button
                type="button"
                className="app-profile-prompt-btn primary"
                onClick={() => {
                  setProfilePromptOpen(false);
                  window.sessionStorage.removeItem(PROFILE_COMPLETION_PROMPT_KEY);
                  window.location.href = "/profile";
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}


      {cartOpen && <Cart onClose={() => setCartOpen(false)} />}
      {favoritesOpen && (
        <Favorites onClose={() => setFavoritesOpen(false)} />
      )}

      {!isAuthenticated && showLoginModal && (
        isSignUp ? (
          <SignUp
            onClose={() => setShowLoginModal(false)}
            onSwitchToSignIn={() => setIsSignUp(false)}
          />
        ) : (
          <SignInModal
            onClose={() => setShowLoginModal(false)}
            onSwitchToSignUp={() => setIsSignUp(true)}
          />
        )
      )}



      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/shipping-and-delivery" element={<ShippingDelivery />} />

        <Route path="/category/:name/*" element={<DiecastStore />} />
        <Route path="/pre-order/*" element={<PreOrderPage />} />
        <Route path="/clearance-sale" element={<Navigate to="/" replace />} />
        <Route path="/clearance-sale/:itemId" element={<Navigate to="/" replace />} />

        <Route path="/combos" element={<ComboListing />} />
        <Route path="/combo/:id" element={<ComboDetail />} />
        <Route path="/Redeempage" element={<Redeempage />} />
        <Route path="/redeempage" element={<Redeempage />} />
        <Route path="/Redeempage/:itemId" element={<RedeemDetailPage />} />
        <Route path="/redeempage/:itemId" element={<RedeemDetailPage />} />
        <Route path="/vendor-partner" element={<Vendor />} />
        <Route path="/membership" element={<Membership />} />
        <Route
          path="/membership/request/:id"
          element={<MembershipRequestPage />}
        />

        <Route path="/event-exclusive" element={<ExclusiveProducts />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route
          path="/payment-processing/:orderId"
          element={<PaymentProcessing />}
        />

        <Route
          path="/order-confirmation/:orderId"
          element={<OrderConfirmation />}
        />
      </Routes>

      <a
        href={whatsappUrl}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <Footer />
    </>
  );
}

export default App;
